const clientMapping = {
    3645: 'trailingLettersLast', // ORBIT440
};

export {
    clientMapping,
}